import { GroupTypes } from '../types/profile';

export const getAdminEditTimeRoles = (): GroupTypes[] => [
  'superuser',
  'timetracker_admin',
  'developer',
];
